import { Pagination, Table, Tag as AntdTag } from "antd";
import {FormattedMessage, useIntl} from "react-intl";
import { useHistory } from "react-router";

import Icon from "../../../components/Icon/Icon";
import Spinner from '../../../components/Spinner/Spinner';
import Tag from "../../../components/Tag/Tag";
import ErrorMessage from "../../../components/ErrorMessage/ErrorMessage";

import { pageSize, usePersonalResourcesTab } from "./usePersonalResources";

import { Props, TableData, TabStatus } from "./PersonalResources.model";

import styles from "./PersonalResources.module.scss";

const PersonalResourcesTab = ({ filters }: Props) => {
	const { getResources, onChangeAllResourcesPagination, state } = usePersonalResourcesTab({ filters });
	const { resources, tabStatus, personalResourcesPagination } = state;
	const intl = useIntl();
	const history = useHistory();

	const columnsApplications = [
		{
			dataIndex: 'title',
			render: (title: string, record: TableData) => (
				<div className={styles.flexCell}>
				{getIconByResourceType(record.type)}
				<span>{title}</span>
			</div>),
			title: intl.formatMessage({ id: 'table.column.resourceName' }),
		},
		{
			dataIndex: 'date',
			title: intl.formatMessage({ id: 'table.column.date' }),
		},
		{
			dataIndex: 'author',
			title: intl.formatMessage({ id: 'table.column.author' }),
		},
		{
			dataIndex: 'tags',
			render: (tags: string[]) => (
				tags?.map((tag, index) => <AntdTag
					key={index}
					style={{
						border: 'none',
						textTransform: 'uppercase'
					}}
				>
					{tag}
				</AntdTag>)
			),
			title: intl.formatMessage({ id: 'table.column.tags' }),
		},
		{
			dataIndex: 'status',
			render: (status: string) => (

				<Tag color={getStatusColor(status.toLowerCase())} noBackground>
					{intl.formatMessage({ id: `status.resource.${status.toLowerCase()}` })}
				</Tag>
			),
			title: intl.formatMessage({ id: 'table.column.status' }),
		},
	];

	const getIconByResourceType = (resourceType: string) => {
		switch (resourceType) {
			case 'Audio': return <Icon name="microphone" color="gray" type="solid" />
			case 'Video': return <Icon name="video" color="gray" type="solid" />
			case 'Text': return <Icon name="file-alt" color="gray" type="solid" />
		}
	}
	
	const getMobileIconByResourceType = (resourceType: string) => {
		switch (resourceType) {
			case 'Audio': return <Icon name="microphone" color="gray" type="solid" width="25px" height="25px"/>
			case 'Video': return <Icon name="video" color="gray" type="solid" width="25px" height="25px"/>
			case 'Text': return <Icon name="file-alt" color="gray" type="solid" width="25px" height="25px"/>
		}
	}

	const getStatusColor = (status: string) => {
		switch (status) {
			case 'published': return 'green';
			case 'unpublished': return 'gray';
			default: return 'gray';
		}
	}

	const onApplicationRow = (rowData: TableData) => {
		return {
			onClick: () => {
				history.push(`/resources/${rowData.id}`);
			},
		};
	}


	return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />
			<ErrorMessage error={tabStatus === TabStatus.Error} onRefresh={getResources} showReport={true}/>
			<div className={styles.table}>
				<Table
					columns={columnsApplications}
					dataSource={resources}
					pagination={false}
					onRow={onApplicationRow}
				/>
			</div>
			<div className={styles.contentMobile}>
				{resources?.map((resource) => {
					return (
						<div
							className={styles.card}
							onClick={() => history.push(`/resources/${resource.id}`)}
						>
							<div className={styles.cardContainer}>
								<div className={styles.iconWrapper}>
									{getMobileIconByResourceType(resource.type)}
								</div>
								<div>
									<h2>
										<FormattedMessage id="table.column.resourceName" />
									</h2>
									<div className={styles.flexCell}>
										<span className={styles.mobileResourceName}>
											{resource.title}
										</span>
									</div>
									<div className={styles.row}>
									<h2 className={styles.label}>
										<FormattedMessage id="table.column.date" />
									</h2>
										<span>{resource.date}</span>
									</div>
									<div className={styles.row}>
										<h2 className={styles.label}>
											<FormattedMessage id="table.column.status" />
										</h2>
									<div>
										<Tag
											color={getStatusColor(resource.status.toLowerCase())}
											noBackground
										>
											{intl.formatMessage({
												id: `status.resource.${resource.status.toLowerCase()}`,
											})}
										</Tag>
									</div>
									</div>
									<div>
										{resource.tags.length ?
											<h2>
												<FormattedMessage id="table.column.tags" />
											</h2> : <></>
										}
										{resource.tags?.map((tag, index) => (
											<AntdTag
												key={index}
												style={{
													border: 'none',
													textTransform: 'uppercase',
												}}
											>
												{intl.formatMessage({ id: `researchAreas.${tag}` })}
											</AntdTag>
										))}
									</div>
								</div>
							</div>
						</div>
					);
				})}
			</div>
			<div className={styles.paginationWrapper}>
				<Pagination
					className={styles.pagination}
					current={personalResourcesPagination.page}
					pageSize={pageSize}
					total={personalResourcesPagination.total}
					onChange={onChangeAllResourcesPagination}
					showSizeChanger={false}
				/>
			</div>
		</div>
	);
}
export default PersonalResourcesTab;